<template>
  <div class="show-gdpr-data">
    <div class="headline">
      <slot name="txtHeadline">Kundendaten herunterladen</slot>
    </div>
    <b-overlay class="btn-next-overlay" :show="loading" spinner-small >
      <div class="content" v-if="currentCustomer !== null">
        <div class="description">
          <slot name="txtBeforeContent">
            <p> Ihre bei uns gespeicherten Daten: </p>
          </slot>
        </div>
        <div class="content-data">
          <b-row v-for="data in getGdprEntries" :key="data.name">
            <b-col class="label">
              {{data.name}}
            </b-col>
            <b-col class="value">
              {{data.value}}
            </b-col>
          </b-row>
        </div>

        <Stepper
          :show-prev="false"
          :loading-next="loadingCSV"
          @next="downloadCSV()"
        >
          <template #btnNext><slot name="btnNext">Download</slot></template>
        </Stepper>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import Stepper from '@/components/generic/Stepper.vue'
import FileSaver from 'file-saver'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'ShowGDPRData',
  components: { Stepper },
  computed: {
    getGdprEntries () {
      return this.currentCustomer?.gdprEntries
    },
    slotData () {
      return {
        currentCustomer: this.currentCustomer
      }
    },
    ...mapGetters([
      'accessToken'
    ])
  },
  data () {
    return {
      currentCustomer: null,
      loading: false,
      loadingCSV: false
    }
  },
  methods: {
    downloadCSV: function () {
      this.loadingCSV = true
      const me = this

      axios.get('/api/document/gdpr/datenauskunft.csv', {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        }
      }).then((response) => {
        this.loadingCSV = false
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'datenauskunft.csv')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  },
  apollo: {
    currentCustomer: function () {
      this.loading = true
      return wrapQuery(
        gql`query GDPRData {
          currentCustomer {
            gdprEntries {
              name,
              value
            }
          }
        }`, this, 'currentCustomer', {}, () => {
          this.loading = false
        },
        {
          fetchPolicy: 'cache-first'
        },
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>
